import React from "react";
import { useMicrositeContext } from "./MicrositeLayout";
import { Card, CardContent } from "../../components/ui/card";
import { Stethoscope, Activity, Pill, Syringe, FileText, Calendar } from "lucide-react";

const SERVICES = [
  { icon: Stethoscope, title: "General consultation", desc: "Routine check-ups, diagnosis and treatment plans." },
  { icon: Activity, title: "Health monitoring", desc: "Vitals, lab follow-ups and chronic-condition management." },
  { icon: Pill, title: "Prescription refills", desc: "Quick refills with digital prescriptions sent to your phone." },
  { icon: Syringe, title: "Vaccinations", desc: "Routine and travel vaccines for all ages." },
  { icon: FileText, title: "Medical certificates", desc: "Fit-to-work, fitness, school and travel certificates." },
  { icon: Calendar, title: "Follow-up visits", desc: "Continuity of care for ongoing treatment plans." },
];

export default function MicrositeServices() {
  const { clinic } = useMicrositeContext();
  const primary = clinic.primary_color || "#2563EB";
  return (
    <div data-testid="microsite-services">
      <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-2" style={{ fontFamily: "Manrope" }}>Services</h1>
      <p className="text-slate-500 mb-8">What we offer at {clinic.name}.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {SERVICES.map((s) => (
          <Card key={s.title} className="border-slate-200">
            <CardContent className="p-6">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center mb-3" style={{ backgroundColor: `${primary}1A`, color: primary }}>
                <s.icon className="w-5 h-5" />
              </div>
              <div className="font-semibold text-slate-900 mb-1" style={{ fontFamily: "Manrope" }}>{s.title}</div>
              <div className="text-sm text-slate-500">{s.desc}</div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
